import {Component, Inject, InjectionToken, OnInit, ViewChild} from '@angular/core';
import {PaymentRequestFindOneByIdService} from '../../../../impl/service/paymentRequestFindOneById.service';
import {BaseView} from '../../../../../../../core/view/base.view';
import {IDialogComponent} from '../../../../../../../common/dialog/iDialog.component';
import {DialogWithInput} from '../../../../../../../common/dialog/dialogWithInput';
import {PAYMENT_REQUEST_STATUS, PaymentRequestModel} from '../../../../api/entity/paymentRequest.model';
import {FormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {
  AccountingMovementCreateFormComponent
} from '../../../../../../../accounting/movement/api/component/accounting-movement-create-form/accounting-movement-create-form.component';
import {MovementType} from '../../../../../../../accounting/movement/api/entity/accountingMovement.model';
import {SALE_DIRECTION} from '../../../../../../api/entity/sale.model';
import {environment} from '../../../../../../../../../environments/environment';
import {HttpClient} from '@angular/common/http';
import {PaymentRequestRepository} from '../../../../impl/service/ngrx/PaymentRequest.repository';
import {SaleFindOneByIdService} from '../../../../../../impl/service/SaleFindOneById.service';

import {
  PaymentRequestOnlineAttemptAddByCardActionService, PaymentRequestOnlineAttemptAddByCardPayload
} from "../../../../payment_request_online_attempt/api/service/paymentRequestOnlineAttemptAddByCardAction.service";
import {
  PaymentRequestOnlineAttemptModel
} from "../../../../payment_request_online_attempt/api/entity/paymentRequestOnlineAttempt.model";
import {DialogController} from "../../../../../../../common/dialog/dialogController";
import {
  PaymentRequestOnlineAttemptCardInProgressDialogComponent, PaymentRequestOnlineAttemptCardInProgressDialogInput
} from "../../../../payment_request_online_attempt/api/component/payment-request-online-attempt-card-in-progress-dialog/payment-request-online-attempt-card-in-progress-dialog.component";
import {PaymentRequestSummaryFindAllService} from "../../../../impl/service/paymentRequestSummaryFindAll.service";
import {UrlParameterBuilder} from "../../../../../../../core/http/UrlParameterBuilder";
import {ExamFormFindOneByIdService} from "../../../../../../../exam-form/impl/service/examFormFindOneById.service";
import {SelectElementV2} from "../../../../../../../../components/common/select/selectElementV2";
import {PaymentRequestSummaryModel} from "../../../../api/entity/paymentRequestSummary.model";
import {Select} from "@ionic/core/dist/types/components/select/select";
import {Order, Sort} from "../../../../../../../../shared/utils/url.builder";

export interface PaymentRequestMovementCreateDialogInput {
  paymentRequestId?: number;
  labelValue: string;
  direction: SALE_DIRECTION;
  partnerId: number;
}
const SERVICE_1 = new InjectionToken<PaymentRequestSummaryFindAllService>('SERVICE_1');
const SERVICE_2 = new InjectionToken<PaymentRequestSummaryFindAllService>('SERVICE_2');

@Component({
  templateUrl: './payment-request-movement-create-dialog.component.html',
  providers: [
    {
      provide: SERVICE_1,
      useClass: PaymentRequestSummaryFindAllService
    },
    {
      provide: SERVICE_2,
      useClass: PaymentRequestSummaryFindAllService
    },
    SaleFindOneByIdService,
    PaymentRequestOnlineAttemptAddByCardActionService
  ]
})
export class PaymentRequestMovementCreateDialogComponent extends BaseView implements
    IDialogComponent<PaymentRequestMovementCreateDialogInput, void>, OnInit {
  @ViewChild('form') movementCreateForm: AccountingMovementCreateFormComponent;
  dialog: DialogWithInput<PaymentRequestMovementCreateDialogInput, void>;
  balance: number;
  amount: number;
  formGroup: UntypedFormGroup;
  loading = false;
  selectedPaymentType: 'CARD_READER' | 'OTHER' = undefined;
  paymentRequestsElements: SelectElementV2<PaymentRequestSummaryModel>[] = [];

  constructor(
      @Inject(SERVICE_1) public paymentRequestFindAllService: PaymentRequestSummaryFindAllService,
      @Inject(SERVICE_2) public paymentRequestFindAllSelectService: PaymentRequestSummaryFindAllService,
              public paymentRequestService: PaymentRequestRepository,
              public saleService: SaleFindOneByIdService,
              public paymentRequestOnlineAttemptAddByCardActionService: PaymentRequestOnlineAttemptAddByCardActionService,
              private httpClient: HttpClient,
              private dialogController: DialogController,
              private formBuilder: FormBuilder) {
    super();
    this.formGroup = new UntypedFormGroup({
      paymentRequestIds: this.formBuilder.control<number[]>([], Validators.required)
    });
  }

  ngOnInit(): void {
    if (this.dialog.input.paymentRequestId) {
      this.formGroup.patchValue({
        paymentRequestIds: [this.dialog.input.paymentRequestId]
      });
      this.loadPaymentRequests();
    } else {
      this.paymentRequestFindAllSelectService.parameters = new UrlParameterBuilder()
          .addParameter('partner.id', this.dialog.input.partnerId)
          .addParameter('direction.value', this.dialog.input.direction)
          .addInParameter('status.value', [
              PAYMENT_REQUEST_STATUS.PAYMENT_REQUEST_STATUS_CREATED,
              PAYMENT_REQUEST_STATUS.PAYMENT_REQUEST_STATUS_SENT
          ])
          .parameters
      this.paymentRequestFindAllSelectService.sort = new Sort('sale.date', Order.DESCENDING);
      this.paymentRequestFindAllSelectService.findAll()
          .then((values) => {
            this.paymentRequestsElements = values.map(value =>{
              let label = value.createdAt.format('DD/MM/YYYY') + ' - ' + value.balance + '€';
              if (value.thirdPartyPartner) {
                label += '(' + value.thirdPartyPartner.name + ')';
              }
             return new SelectElementV2<PaymentRequestSummaryModel>(value.id, label, value);
            });
          });
    }
  }

  loadPaymentRequests() {
    const paymentRequestIds: number[] = this.formGroup.get('paymentRequestIds').value;
    this.balance = 0;
    if (paymentRequestIds?.length > 0) {
      this.paymentRequestFindAllService.parameters = new UrlParameterBuilder()
          .addInParameter('id', paymentRequestIds)
          .parameters;
      this.paymentRequestFindAllService.findAll().then(values => {
        this.refreshBalance(values);
      });
    }
  }

  refreshBalanceFromUI(events: SelectElementV2<PaymentRequestSummaryModel>[]): void {
    this.refreshBalance(events.map(value => value.element));
  }

  refreshBalance(paymentRequests: PaymentRequestSummaryModel[]) {
    this.balance = paymentRequests.map(value => value.balance).reduce((a, b) => a + b);
  }

  get movementType(): MovementType {
    return this.dialog.input.direction === SALE_DIRECTION.SALE_DIRECTION_IN ?
        MovementType.EXPENDITURE : MovementType.REVENUE;
  }

  buildAttemptPayload = (): PaymentRequestOnlineAttemptAddByCardPayload => {
    /* const payload: PaymentRequestOnlineAttemptAddByCardPayload = Object.assign(new PaymentRequestOnlineAttemptAddByCardPayload(), this.formGroup.value);
    payload.paymentRequestId = this.paymentRequest.summary.id
    return payload; */
    return undefined;
  };

  attemptSuccess(response: PaymentRequestOnlineAttemptModel) {
    this.dialog.close();
    this.dialogController.open(PaymentRequestOnlineAttemptCardInProgressDialogComponent, {
      paymentRequestAttemptId: response.summary.id
    } as PaymentRequestOnlineAttemptCardInProgressDialogInput, {
      title: 'Paiement sur le lecteur de carte'
    });
  }

  save() {
    const movementPayload = this.movementCreateForm.buildPayload();
    const payload = {
      paymentRequestIds: this.formGroup.get('paymentRequestIds').value,
      accountingMovement: {
        date: movementPayload.date,
        accountingAccountId: this.movementType === MovementType.EXPENDITURE
            ? movementPayload.sourceAccountId : movementPayload.targetAccountId,
        paymentTypeValue: movementPayload.paymentTypeValue,
        check: movementPayload.check,
        amount: movementPayload.amount,
        labelValue: movementPayload.labelValue,
        comment: movementPayload.comment,
      }
    };

    this.loading = true;
    this.httpClient.post(environment.webserviceUrl + '/v1/payment-request/movement/add-to-multiple-payment-requests', payload).toPromise()
        .then(() => {
          this.paymentRequestService.clearCache();
          this.toastControl.presentConfirmation('Paiement àjouté');
          this.saleService.reload();
          this.dialog.close();
        })
        .catch((e) => this.toastControl.presentError(e))
        .finally(() => this.loading = false);
  }

  amountChanged(amount: number) {
    // console.logByType'amouunt changed ' + amount);
    this.amount = amount;
  }

}
